<template>
  <b-container fluid>
    <!-- Search Form -->
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('institute_manangement.id_card_list')}}</h4>
      </template>
      <template v-slot:body>
         <b-row>
            <!-- <b-col xs="12" sm="12" md="12" lg="12" xl="12" class="text-center">
                <b-form-group label="" v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    id="radio-slots"
                    v-model="search.is_resident"
                    :aria-describedby="ariaDescribedby"
                    name="radio-options-slots"
                  >
                    <template #first>
                      <b-form-radio :value="1">{{ $t('institute_manangement.resident')}}</b-form-radio>
                    </template>
                    <b-form-radio :value="0">{{ $t('institute_manangement.guardian')}}</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
            </b-col> -->
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group
                class="row"
                label-cols-sm="4"
                :label="$t('educational_management.fiscal_year')"
                label-for="fiscal_year"
              >
                <b-form-select
                  plain
                  v-model="search.fiscal_year_id"
                  :options="fiscalYearList"
                  id="fiscal_year"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group
                class="row"
                label-cols-sm="4"
                label-for="organiation_id"
              >
                <template v-slot:label>
                  {{$t('globalTrans.organization')}}
                </template>
                <b-form-select
                  plain
                  v-model="search.org_id"
                  :options="orgList"
                  id="organiation_id"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="office_type_id"
                    >
                    <template v-slot:label>
                        {{$t('child_configuration.institute_type')}}
                    </template>
                    <b-form-select
                    plain
                    v-model="search.office_type_id"
                    :options="officeTypeList"
                    id="office_type_id"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group
                class="row"
                label-cols-sm="4"
                label-for="office_id"
              >
                <template v-slot:label>
                  {{$t('child_configuration.institute_name')}}
                </template>
                <b-form-select
                  plain
                  v-model="search.office_id"
                  :options="officeList"
                  id="office_id"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
         </b-row>
         <b-row>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('institute_manangement.registration_id')"
                    label-for="registration_id"
                >
                <b-form-input
                    id="registration_id"
                    v-model="search.registration_id"
                    placeholder=""
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-button variant="primary" @click="searchData()">{{ $t('globalTrans.search') }}</b-button>
            </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('institute_manangement.id_card_list')}}</h4>
          </template>
          <template v-slot:headerAction>
            <b-dropdown id="dropdown-left1" :text="$t('institute_manangement.export_pdf')" variant="light" size="sm">
                <b-dropdown-item @click="pdfExport(status=1)">
                  <i class="ri-download-cloud-fill"></i>
                  {{ $t('globalTrans.all') + ' ' + $t('institute_manangement.resident') }}
                </b-dropdown-item>
                <b-dropdown-item @click="pdfExport(status=2)">
                  <i class="ri-download-cloud-fill"></i>
                  {{ $t('globalTrans.all') + ' ' + $t('institute_manangement.guardian') }}
                </b-dropdown-item>
            </b-dropdown>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(contact_no)="data">
                      <span class="capitalize">{{ data.item.contact_no | mobileNumber }}</span>
                    </template>
                    <template v-slot:cell(action)="data">
                        <b-dropdown id="dropdown-left" :text="$t('globalTrans.print')" variant="primary" size="sm">
                          <b-dropdown-item v-b-modal.modal-4 @click="view(data.item, status=1)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                              <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                              <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
                            </svg>
                            {{ $t('institute_manangement.resident') }}
                          </b-dropdown-item>
                          <b-dropdown-item v-b-modal.modal-4 @click="view(data.item, status=2)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                              <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                              <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
                            </svg>
                            {{ $t('institute_manangement.guardian') }}
                          </b-dropdown-item>
                        </b-dropdown>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <!-- Table/List -->

    <b-modal id="modal-4" size="lg" :title="$t('institute_manangement.id_card_details')"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Form :id="editItemId" :key="editItemId" :status="status"/>
    </b-modal>
  </b-container>
</template>

<script>
import Form from './Form'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { idCardList } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import ExportPdf from './export-pdf'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    Form
  },
  data () {
    return {
      editItemId: 0,
      status: 0,
      search: {
        fiscal_year_id: 0,
        org_id: 0,
        office_type_id: 0,
        office_id: 0,
        registration_id: '',
        is_resident: 1
      },
      officeTypeList: [],
      officeList: [],
      rows: [],
      reportData: []
    }
  },
  computed: {
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('globalTrans.organization'), class: 'text-center' },
          { label: this.$t('institute_manangement.institute_name'), class: 'text-center' },
          { label: this.$t('institute_manangement.registration_id'), class: 'text-center' },
          { label: this.$t('institute_manangement.mobile'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'org_name_bn' },
          { key: 'office_name_bn' },
          { key: 'registration_id' },
          { key: 'contact_no' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'org_name' },
          { key: 'office_name' },
          { key: 'registration_id' },
          { key: 'contact_no' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
      })
    }
  },
  watch: {
    'search.org_id': function (newVal, oldVal) {
       this.getOfficeTypeList()
    },
    'search.office_type_id': function (newVal, oldVal) {
       this.getOfficeList()
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.search.org_id) {
                this.getOfficeTypeList()
            }
            if (this.search.office_type_id) {
                this.getOfficeList()
            }
        }
    }
  },
  created () {
      this.search.org_id = this.$store.state.dataFilters.orgId
      this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.search.office_id = this.$store.state.dataFilters.officeId
    this.loadData()
  },
  mounted () {
  },
  methods: {
    searchData () {
      this.loadData()
    },
    view (item, status) {
      this.editItemId = item.id
      this.status = status
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(childServiceBaseUrl, idCardList, params).then(response => {
          if (response.success) {
            this.$store.dispatch('setList', this.formatData(response.data.data))
            this.paginationData(response.data)
            this.reportData = response.data
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    formatData (data) {
        const tmp = data.map(item => {
            const org = this.$store.state.commonObj.organizationProfileList.find(imt => imt.value === item.org_id)
            const officeType = this.$store.state.commonObj.officeTypeList.find(imt => imt.value === item.office_type_id)
            const office = this.$store.state.commonObj.officeList.find(imt => imt.value === item.office_id)
            return Object.assign({}, item, { org_name: org?.text_en, org_name_bn: org?.text_bn, office_type_name: officeType?.text_en, office_type_name_bn: officeType?.text_bn, office_name: office?.text_en, office_name_bn: office?.text_bn })
        })
        return tmp
    },
    getOfficeTypeList () {
        this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id && [15, 53, 28, 16, 18, 22, 17, 25, 24, 43, 52, 51, 44, 23, 31, 54, 49, 13, 55, 47, 46, 50, 48, 19, 21, 3].includes(item.value)).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getOfficeList () {
        this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    pdfExport (printStatus) {
        const reportTitle = this.$t('institute_manangement.ministry_welfare')
        ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.reportData, this, printStatus)
    }
  }
}
</script>
